import { createSlice } from '@reduxjs/toolkit';

const initialStateCommercialList = {
    listLoading: false,
    actionsLoading: false,
    pAgreementCommercial: undefined,
    pAgreementCommercialDetail: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const pCommercialListSlice = createSlice({
    name: "pAgreementCommercial",
    initialState: initialStateCommercialList,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List agency
        commercialListFetched: (state, action) => {
            state.listLoading = false;
            state.pAgreementCommercial = action.payload.pAgreementCommercial;
            state.error = null;
        },
        // get agency detail
        commercialDetailFetched: (state, action) => {
            state.listLoading = false;
            state.pAgreementCommercialDetail = action.payload.pAgreementCommercialDetail;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pAgreementCommercialDetail = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pAgreementCommercial = undefined;
            state.pAgreementCommercialDetail = undefined;
            state.error = null;
            state.success = null;
        }
    }
});